import { getPDFDocument, getRGB } from "./pdf-lib-loader";

// Initialize pdf-lib functions
let PDFDocument: any;
let rgb: any;

// Load pdf-lib functions asynchronously
async function initializePDFLib() {
  if (!PDFDocument || !rgb) {
    PDFDocument = await getPDFDocument();
    rgb = await getRGB();
  }
}

/**
 * rule position
 */
export interface RulePosition {
  page: number;
  y: number;
}

/**
 * rule to link
 */
export interface RulesToLink {
  ruleId: string;
  page: number;
  x: number;
  y: number;
  width: number;
  height: number;
  withUnderline: boolean;
  insertedPages?: boolean;
}

export default class RulesLinker {
  private pdfDoc: any;
  private rulePageNumber: Record<string, RulePosition>;
  private numberInsertedPages: number = 0;
  private rulesToLink: Array<RulesToLink> = [];

  constructor(pdfDoc: any) {
    this.pdfDoc = pdfDoc;
    this.rulePageNumber = {};
  }

  addRulePageNumber(ruleId: string, page: number, y: number): void {
    this.rulePageNumber[ruleId] = { page, y };
  }

  getRulePageNumber(ruleId: string): RulePosition | null {
    return this.rulePageNumber[ruleId] || null;
  }

  setNumberInsertedPages(number: number): void {
    this.numberInsertedPages = number;
  }

  getNumberInsertedPages(): number {
    return this.numberInsertedPages;
  }

  /**
   * dessine un soulignement sous l lien
   */
  private async underline({
    page,
    x,
    y,
    width,
  }: {
    page: any;
    x: number;
    y: number;
    width: number;
  }) {
    // Initialize pdf-lib if needed
    await initializePDFLib();

    // Ajouter un soulignement si nécessaire
    page.drawLine({
      start: { x, y: y - 2 },
      end: { x: x + width, y: y - 2 },
      thickness: 0.5,
      color: rgb(0, 0, 0.8),
    });
  }
  /**
   ** générer un lien
   */
  private generateLink({
    ruleId,
    page,
    x,
    y,
    width,
    height,
    withUnderline,
    insertedPages = false,
  }: {
    ruleId: string | number;
    page: number;
    x: number;
    y: number;
    width: number;
    height: number;
    withUnderline: boolean;
    insertedPages?: boolean;
  }): void {
    if (!this.pdfDoc) {
      throw new Error("PDF document not initialized");
    }

    if (this.numberInsertedPages > 0 && !insertedPages) {
      page = page + this.numberInsertedPages;
    }

    const currentPage = this.pdfDoc.getPages()[page - 1];
    const targetNumber = this.rulePageNumber[ruleId] || null;

    // Créer un lien vers la règle si on a sa position
    if (targetNumber && typeof targetNumber === "object" && targetNumber.y) {
      const pageNumber = targetNumber.page - 1 + this.numberInsertedPages;
      const targetPage = this.pdfDoc.getPages()[pageNumber];
      if (targetPage) {
        const linkAnnot = this.pdfDoc.context.obj({
          Type: "Annot",
          Subtype: "Link",
          Rect: [x - 5, y - 2, x + 10 + width, y + height + 4],
          Dest: [targetPage.ref, "XYZ", null, targetNumber.y, null],
          Border: [0, 0, 0],
        });

        currentPage.node.addAnnot(this.pdfDoc.context.register(linkAnnot));
        if (withUnderline) {
          this.underline({
            page: currentPage,
            x: x,
            y: y,
            width: width,
          });
        }
      } else {
        console.log("targetPage not found:", targetNumber.page);
      }
    }
  }

  addRuleToLink(ruleToLink: RulesToLink): void {
    if (
      typeof ruleToLink.x === "undefined" ||
      typeof ruleToLink.y === "undefined" ||
      typeof ruleToLink.width === "undefined" ||
      typeof ruleToLink.height === "undefined"
    ) {
      console.error("ruleToLink", ruleToLink);
      return;
    }
    // console.log("addRuleToLink", ruleToLink);
    this.rulesToLink.push(ruleToLink);
  }

  generateLinks(): void {
    this.rulesToLink.forEach((ruleToLink) => {
      this.generateLink(ruleToLink);
    });
  }
}
